import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  async submit(event) {
    event.preventDefault()

    const button = event.currentTarget

    // Nothing here disabled the button, so an impatient second click became a
    // second POST. On 2026-08-14 a busy main thread queued three clicks and
    // dispatched them together, and expense 2864 got three approval requests.
    if (button.disabled) {
      return
    }

    const confirmMessage = button.dataset.turboConfirm

    // Show confirmation dialog if needed
    if (confirmMessage && !confirm(confirmMessage)) {
      return
    }

    // Find the form dynamically - it's the parent of the button
    const form = button.closest("form")
    if (!form) {
      console.error("Form not found for button:", button)
      return
    }

    const formData = new FormData(form)
    button.disabled = true

    // Send POST request with Turbo Stream accept header
    try {
      const response = await post(form.action, {
        body: formData,
        responseKind: "turbo-stream"
      })

      if (!response.ok) {
        console.error("Submit for approval failed:", response)
      }
    } finally {
      // A successful response replaces the whole tab pane, so this often runs
      // against a detached node — harmless, and it restores the button when the
      // request failed and the pane is still on screen.
      button.disabled = false
    }
  }
}
